import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import initHead from './head'
import Launcher404Page from './404Page.vue'

const Routers = {
  name: 'routerPlugin',
  createRouter(Launcher, routes, routerOptions = {}) {
    const routesWith404 = [
      ...routes,
      {
        path: '/:catchAll(.*)',
        name: 'Launcher404Page',
        component: Launcher404Page,
        meta: {
          title: '你访问的页面不见了',
        },
      },
    ]

    const config = {
      routes: routesWith404,
      history: routerOptions.history || (process.env.BROWSER ? createWebHistory() : createMemoryHistory()),
      linkActiveClass: 'active',
    }

    if (Launcher.isBrowser && routerOptions.scrollBehavior) {
      config.scrollBehavior = routerOptions.scrollBehavior
    }

    return createRouter(config)
  },

  install(app, Launcher, { routes, routerOptions }) {
    const router = this.createRouter(Launcher, routes, routerOptions)
    app.vm.use(router)

    // SSR 时每次需要重新构建
    app.router = router
    app.vm.config.globalProperties.router = router

    initHead(app, Launcher)
  },
}

export default Routers
